import { render, staticRenderFns } from "./PortalIndex.vue?vue&type=template&id=402b4514&scoped=true&"
import script from "./PortalIndex.vue?vue&type=script&lang=js&"
export * from "./PortalIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b4514",
  null
  
)

export default component.exports